<template>
  <div id="create-study-set-overview">
    <div class="base-create">
      <div class="create-class-overview">
        <el-row class="mb-px-16">
          <el-col :span="14">
            <div class="info-row">
              <p>
                <span class="label">{{ $t('study_sets.overview.study_set_name') }}:</span> <span class="value">{{ studysetDetails.name }}</span>
              </p>
            </div>
          </el-col>
          <el-col :span="10">
            <div class="info-row">
              <p>
                <span class="label">{{ $t('study_sets.overview.shareable') }}:</span> <span class="value">{{ $t($i18nLabelsHelper(currentOrganizationType, `study_sets.${studysetDetails.shareable}`)) }}</span>
              </p>
            </div>
          </el-col>
        </el-row>
        <el-row class="mb-px-16">
          <el-col :span="14">
            <div class="info-row">
              <p>
                <span class="label">{{ $t('study_sets.overview.category') }}:</span> <span class="value">{{ getCategoryLabel(studysetDetails.category) }}</span>
              </p>
            </div>
          </el-col>
          <el-col :span="10">
            <div class="info-row">
              <p>
                <span class="label">{{ $t('study_sets.overview.phrases_count') }}:</span> <span class="value">{{ phrases_count }}</span>
              </p>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="info-row mb-px-16">
              <p>
                <span class="label">{{ $t('study_sets.overview.phrases_list_title') }}:</span>
              </p>
            </div>
            <div id="phrases-wrapper" v-bind:class="{ 'error-pharses': studysetDetails && studysetDetails.phrases && studysetDetails.phrases.some((x) => x.error) }">
              <ul class="list-none" id="phrases-list">
                <li v-for="phrase in studysetDetails.phrases" :key="phrase.text">
                  <div class="phrase">
                    <el-tooltip :content="$t('study_sets.overview.phrases_add_success')" placement="top-start" v-if="phrase.success"><i class="elsa-icon-check-circle" /></el-tooltip>
                    <el-tooltip :content="$t('study_sets.overview.phrases_add_changed', {original_text: phrase.original_text})" placement="top-start" v-else-if="phrase.warning"><i class="el-icon-warning" /></el-tooltip>
                    <el-tooltip :content="$t('study_sets.overview.phrases_add_fail')" placement="top-start" v-else-if="phrase.error"><i class="elsa-icon-exclamation-circle" /></el-tooltip>
                    <i v-else style="color: transparent" />
                    <span v-bind:class="{ 'spell-error': phrase.classes && phrase.spell_error, 'cleanup-text': phrase.is_cleanup }">{{ phrase.text }}</span>
                  </div>
                  <div class="icon-wrap">
                    <span class="icon" v-for="skill in phrase.skills_support" :key="skill">
                      <i :class="`elsa-skill-` + skill" />
                    </span>
                  </div>
                </li>
              </ul>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
// import Chip from "@/components/common/Chip";
import { pathOr, isNil } from 'ramda'
import { mapGetters } from 'vuex'
import { DefaultShareableOptions, DefaultCategoryOptions } from '@/constants/studySets'
import { getOptionsLabels } from '@/utils/elementUi'

export default {
  components: {},
  props: {
    studysetDetails: {},
    organizationType: {},
    editClass: {
      type: Function,
      default: () => {}
    },
    showEditClass: {
      type: Boolean,
      default: true
    },
    showUserInfo: {
      type: Boolean,
      default: true
    },
    organizationId: {},
    uploadId: {
      default: null
    }
  },
  data() {
    return {
      error: '',
      shareableOptions: DefaultShareableOptions
    }
  },
  computed: {
    startEndDate() {
      const not_selected = this.$t('classes.create_class_flow.class_overview.not_selected')
      const start_date = isNil(this.studysetDetails.startDate) ? not_selected : new Date(this.studysetDetails.startDate).toDateString()
      const end_date = isNil(this.studysetDetails.endDate) ? not_selected : new Date(this.studysetDetails.endDate).toDateString()

      return `${start_date} - ${end_date}`
    },
    classId() {
      return pathOr(null, ['studysetDetails', 'id'])(this)
    },
    ...mapGetters({
      currentUser: 'user/getUser',
      currentOrganizationType: 'organization/currentOrganizationType'
    }),
    phrases_count() {
      if (this.studysetDetails && this.studysetDetails.phrases) {
        return this.studysetDetails.phrases.length
      }
      return 0
    }
  },
  methods: {
    getShareableLabel(v) {
      return getOptionsLabels(DefaultShareableOptions, v)
    },
    getCategoryLabel(v) {
      return getOptionsLabels(DefaultCategoryOptions, v)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/_colors.scss';
h3 {
  text-transform: none;
}
.class-teacher {
  margin-top: 40px;
  .user-info {
    display: flex;
    flex-direction: column;
    .name {
      color: $black;
    }
  }
}
p {
  font-weight: 300;
  font-size: 18px;
  color: $dark-blue-2;
  margin: 0;
}
.practice {
  display: flex;
  align-items: center;
  margin-top: 24px;
  .input-wrapper {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    color: $black;
    .goal-value {
      font-weight: bold;
      font-size: 20px;
      color: #478dff;
      padding: 0 5px;
    }
  }
  .description {
    p {
      margin-top: 5px;
      font-size: 16px;
      line-height: 24px;
      opacity: 0.7;
    }
    .assessment-test-title {
      font-weight: 500;
      font-size: 20px;
      line-height: 24px;
      color: $black;
      opacity: 1;
    }
  }
  .box-card {
    border: 1px solid #e6e6e6;
    box-sizing: border-box;
    border-radius: 16px;
    // margin-bottom: 24px;
    height: 214px;
    width: 100%;
    ::v-deep .el-card__body {
      align-items: flex-start;
      .card-number {
        margin-bottom: 8px;
      }
      .card-content {
        flex: 1 0;

        h2 {
          font-size: 24px;
          line-height: 36px;
          color: #121131;
        }

        p {
          font-size: 16px;
          line-height: 24px;
          color: #121131;
        }

        button {
          float: right;
        }
      }
    }
  }
}
.line-separate {
  border: 1px solid#E6E6E6;
  margin: 40px 0 32px;
}

#create-study-set-overview {
  background: #ffffff;
  border: 1px solid #d8d8d8;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 24px 32px;
}

.info-row {
  p {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #757575;
    margin: 0;
    text-align: initial;
  }

  .value {
    color: $black;
    text-transform: none;
    margin-bottom: 4px;
  }

  // .values {
  //   margin-top: 5px;
  //   p {
  //     color: $black;
  //     text-transform: none;
  //     margin-bottom: 4px;
  //     font-weight: 500;
  //   }
  // }
  // p {
  //   font-weight: 600;
  //   font-size: 17px;
  //   color: $dark-blue-2;
  //   margin: 0;
  //   text-align: initial;
  //   text-transform: capitalize;
  // }
}

.error-row {
  p {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: red;
    margin: 0;
    text-align: initial;
  }
}

#phrases-wrapper {
  background: #edf4ff;
  border-radius: 8px;
  padding: 16px;

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background-color: #edf4ff;
    border-radius: 100px;
  }

  &::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 8px #c2c2c2;
    border-radius: 100px;
  }
}

#phrases-list {
  overflow: auto;
  height: 250px;
  padding-left: 0px;
  margin-top: 12px;
  margin-bottom: 12px;
  display: flex;
  flex-direction: column;
  padding: 0;

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background-color: #edf4ff;
    border-radius: 100px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #c2c2c2;
    // box-shadow: inset 0 0 8px #C2C2C2;
    border-radius: 100px;
  }
  .spell-error {
    text-decoration-line: underline;
    color: #EB001B;
  }
  .cleanup-text {
    text-decoration-line: underline;
    color: #ff9f00;
  }
}

#phrases-list li {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */
  color: #121131;
  margin-bottom: 16px;
  display: flex;
  .phrase {
    display: flex;
    border: 0.5px solid #cee0ea;
    background: #e9e9ec;
    padding: 0 10px;
    border-radius: 4px;
    .el-icon-warning {
      font-size: 18px;
      color: #ff9f00;
      padding: 4px 6px 0px 0px;
    }
  }
  .icon-wrap {
    padding-left: 14px;
    display: flex;
    flex-wrap: wrap;

    .icon {
      margin: 0 0px 0px 0;
    }

    i {
      width: 24px;
      height: 24px;
    }
  }
}
.error-pharses {
  border: 1px solid red;
}
</style>
